import * as types from "./types";

export const getCompanyRolesRequest = (payload) => ({
  type: types.GET_COMPANY_ROLES_REQUEST,
  payload,
});

export const getCompanyRolesResponse = (payload) => ({
  type: types.GET_COMPANY_ROLES_RESPONSE,
  payload,
});

export const createCompanyRoleRequest = (payload) => ({
  type: types.CREATE_COMPANY_ROLE_REQUEST,
  payload,
});

export const createCompanyRoleSuccess = (payload) => ({
  type: types.CREATE_COMPANY_ROLE_SUCCESS,
  payload,
});

export const createCompanyRoleFailure = (payload) => ({
  type: types.CREATE_COMPANY_ROLE_FAILURE,
  payload,
});

export const getCompanyRoleRequest = (payload) => ({
  type: types.GET_COMPANY_ROLE_REQUEST,
  payload,
});

export const getCompanyRoleResponse = (payload) => ({
  type: types.GET_COMPANY_ROLE_RESPONSE,
  payload,
});

export const clearCompanyRole = () => ({
  type: types.CLEAR_COMPANY_ROLE,
});

export const updateCompanyRoleRequest = (payload) => ({
  type: types.UPDATE_COMPANY_ROLE_REQUEST,
  payload,
});

export const updateCompanyRoleSuccess = (payload) => ({
  type: types.UPDATE_COMPANY_ROLE_SUCCESS,
  payload,
});

export const updateCompanyRoleFailure = (payload) => ({
  type: types.UPDATE_COMPANY_ROLE_FAILURE,
  payload,
});

export const deleteCompanyRoleRequest = (payload) => ({
  type: types.DELETE_COMPANY_ROLE_REQUEST,
  payload,
});

export const deleteCompanyRoleSuccess = (payload) => ({
  type: types.DELETE_COMPANY_ROLE_SUCCESS,
  payload,
});

export const deleteCompanyRoleFailure = (payload) => ({
  type: types.DELETE_COMPANY_ROLE_FAILURE,
  payload,
});
